import { useState } from "react";
import ReactMarkdown from "react-markdown";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { atomDark } from "react-syntax-highlighter/dist/esm/styles/prism";
import remarkMdx from "remark-mdx";
import { PiCopyDuotone } from "react-icons/pi";
import { useWindowSize } from "../../shared/hooks/useWindowSize";
import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";

const CodeBlock = ({
  node,
  inline,
  className,
  children,
  ...props
}: {
  node: any;
  inline: any;
  className: any;
  children: any;
}) => {
  const match = /language-(\w+)/.exec(className || "");
  const codeString = String(children).replace(/\n$/, "");
  const [isCopied, setIsCopied] = useState(false);
  const windowSize = useWindowSize();

  const handleCopy = () => {
    navigator.clipboard.writeText(codeString);
    setIsCopied(true);
    setTimeout(() => setIsCopied(false), 2000);
  };

  return match ? (
    <div className="relative ">
      <SyntaxHighlighter
        style={atomDark}
        PreTag="div"
        wrapLongLines
        customStyle={{
          overflowX: "scroll",
        }}
        language={match ? match[1] : "dart"}
        {...props}
      >
        {codeString}
      </SyntaxHighlighter>
      <button
        className={`absolute top-2 right-4 p-1 rounded btn btn-sm focus:outline-none`}
        onClick={handleCopy}
      >
        {isCopied ? (
          <div className="text-green-400">
            <PiCopyDuotone
              className="inline-block"
              size={20}
            />
            Copied!
          </div>
        ) : (
          <>
            <div className="text-base-content">
              <PiCopyDuotone
                className="inline-block hover:text-primary/80"
                size={20}
              />
            </div>
          </>
        )}
      </button>
    </div>
  ) : (
    <code
      className={className}
      {...props}
    >
      {children}
    </code>
  );
};

const MarkdownRenderer = ({ content }: { content: string }) => {
  const clean = content; //escapeHtml(response);

  return (
    <div
      className=""
      onMouseUp={(event) => {
        event.preventDefault();
        console.log("Mouse up: ", window.getSelection()?.toString());
      }}
    >
      <ReactMarkdown
        className="prose prose-pre:p-0 leading-normal text-sm md:text-base space-y-3 break-words"
        remarkPlugins={[remarkGfm]}
        components={{
          code({ node, inline, className, children, ...props }: any) {
            /* console.log("Inline: ", inline);
            console.log("Node: ", node);
            console.log("Children: ", children);
            console.log("Props: ", props) */
            inline =
              inline ?? node.position.start.line === node.position.end.line;
            return (
              <CodeBlock
                node={node}
                inline={inline}
                className={
                  (inline ? className : className ?? "language-text")
                }
                children={children}
              />
            );
          },
          /* p: ({ children }) => {
            return <Paragraph>{children}</Paragraph>;
          }, */
        }}
      >
        {clean}
      </ReactMarkdown>
    </div>
  );
};

export default MarkdownRenderer;